import { render, staticRenderFns } from "./ConfiguratorV2.vue?vue&type=template&id=868aa7c0&scoped=true"
import script from "./ConfiguratorV2.vue?vue&type=script&lang=js"
export * from "./ConfiguratorV2.vue?vue&type=script&lang=js"
import style0 from "./ConfiguratorV2.vue?vue&type=style&index=0&id=868aa7c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868aa7c0",
  null
  
)

export default component.exports